/**
 * The fields the membership fields has
 */
export const fields = {
    membership_group : null, //Object holding the membership group
    membership_type  : null, //Object holding the membership type
    payment_type     : {
        value : 'annual',
        label : 'Annual'
    }, //If we're using annual or biannual payments
    ignore_renewal_notification : false, //if the user doesn't want renewal notifications
    fields                      : {},
    organisation                : {
        name                                    : '',
        how_did_you_hear_about_us               : '',
        how_did_you_hear_about_us_other         : '',
        consents_to_data_processing_and_storage : false
    }, //If the type is for an organisation
    individual: {
        title                                   : '',
        other_title                             : '',
        forename                                : '',
        middle_name                             : '',
        surname                                 : '',
        how_did_you_hear_about_us               : '',
        how_did_you_hear_about_us_other         : '',
        consents_to_data_processing_and_storage : false
    }, //if the type is for an individual
    contact: {
        email                       : '',
        email_confirmation          : '',
        contact_number              : '',
        contact_number_confirmation : '', 
        mobile_number               : '',
        address_line_1              : '',
        address_line_2              : '',
        city                        : '',
        postcode                    : '',
        county                      : '',
        country                     : ''
    }, //the contact details for the member type
    user: {
        name               : '',
        email              : '',
        email_confirmation : ''
    }, //the details to create an account with
}